
const utilClass = {
  contains: function (arr, key1, obj, key2) {
    var i = arr.length
    var data = {}
    var obj2 = key2 ? obj[key2] : obj
    while (i--) {
      if (arr[i][key1] + '' === obj2 + '') {
        data = arr[i]
        data.i = i
        return data
      }
    }
    return false
  },
  // 时间戳转字符串
  formatDate: function (value, type) {
    if (value) {
      var date = new Date(parseInt(value))
      if (/(y+)/.test(type)) {
        type = type.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'H+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
      }
      var padLeftZero = function (str) {
        return ('00' + str).substr(str.length)
      }
      for (let k in o) {
        if (new RegExp(`(${k})`).test(type)) {
          let str = o[k] + ''
          type = type.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
        }
      }
      return type
    }
  },
  /* 处理粘贴图片 */
  pastePicture: function (e, bus) {
    let that = this
    console.log(e)
    var imgReader = function (item) {
      var blob = item.getAsFile()
      var reader = new FileReader()
      var browser = that.browserInfo()
      reader.readAsDataURL(blob)
      reader.onload = function (ev) {
        var img = new Image()
        img.src = ev.target.result
        console.log(browser)
        if (browser.chrome) {
          if (bus) {
            bus.emit('file-basc64', ev.target.result)
          } else {
            that._insertimg('<img src="' + ev.target.result + '" />', 'messageBox2')
          }
        }
      }
    }
    var clipboardData = e.clipboardData
    var i = 0
    var items, item, types
    if (clipboardData) {
      items = clipboardData.items
      if (!items) {
        return
      }
      item = items[0]
      types = clipboardData.types || []
      for (; i < types.length; i++) {
        if (types[i] === 'Files') {
          item = items[i]
          break
        }
      }
      if (item && item.kind === 'file' && item.type.match(/^image\//i)) {
        imgReader(item)
      }
    }
  },
  // 国际手机号处理（验证、参数处理）
  phoneVerify (codeId, phone, arr) {
    let json = {}
    let obj = arr.find(v => {
      return v.id === codeId
    })
    console.log(obj)
    if (obj) {
      if (obj.value === '86' && !obj.reg.test(phone)) {
        json.error = '联系电话格式不正确'
      }
      json.prefix = '+' + obj.value + '-'
      if (obj.value === '86') {
        json.phone = phone
      } else {
        json.phone = '+' + obj.value + '-' + phone
      }
    }
    if (!phone) {
      json.error = '联系电话不能为空'
    }
    return json
  },
  phoneParsing (phone) {
    let json = {
      phone: '',
      prefix: localStorage.countryValue || '86'
    }
    if (phone && phone.includes('-')) {
      var arr = phone.split('-')
      json = {
        prefix: arr[0].substr(1),
        phone: arr[1]
      }
    } else {
      json.phone = phone
    }
    return json
  },
  // 加密
  encrypt (obj) {
    let newCryptoJS = window.CryptoJS
    let pwd = 'teamface2019team'
    let key = newCryptoJS.enc.Utf8.parse(pwd)
    let srcs = newCryptoJS.enc.Utf8.parse(obj)
    let encrypted = newCryptoJS.AES.encrypt(srcs, key, {mode: newCryptoJS.mode.ECB, padding: newCryptoJS.pad.Pkcs7})
    return encrypted.toString()
  },
  decrypt (res) {
    let content = res.biz_content
    if (typeof res === 'string') {
      content = res
    }
    let newCryptoJS = window.CryptoJS
    let pwd = 'teamface2019team'
    let key = newCryptoJS.enc.Utf8.parse(pwd)
    let encrypted = newCryptoJS.AES.decrypt(content, key, {mode: newCryptoJS.mode.ECB, padding: newCryptoJS.pad.Pkcs7}).toString(newCryptoJS.enc.Utf8)
    return encrypted ? JSON.parse(encrypted) : {}
  }
}
export default utilClass



// WEBPACK FOOTER //
// ./src/common/js/tool.js